// components/StatusSummaryCards.tsx
import React from 'react';

const statusMappingReverse: Record<number, string> = {
  1: "Pending",
  2: "Approved",
  3: "Rejected"
};

export const StatusCard = ({ title, value, iconClass, bgClass }: any) => (
  <div className="col-xl-3 col-md-6 d-flex">
    <div className="card flex-fill">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-2">
              <span className={`p-2 br-10 ${bgClass} d-flex align-items-center justify-content-center`}>
                <i className={iconClass} />
              </span>
            </div>
            <div>
              <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">{title}</p>
              <h4>{value}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const getStatusSummary = (data: any[], statusField: string = 'status') => {
  const summary = { total: data.length, approved: 0, pending: 0, rejected: 0 };
  data.forEach(item => {
    const rawStatus = item[statusField];
    const status = typeof rawStatus === 'number'
      ? statusMappingReverse[rawStatus]?.toLowerCase()
      : rawStatus?.toLowerCase();

    if (status === 'approved') summary.approved++;
    else if (status === 'pending') summary.pending++;
    else if (status === 'rejected') summary.rejected++;
  });
  return summary;
};

export const getStatusCards = (data: any[], statusField: string) =>
  Object.entries(getStatusSummary(data, statusField)).map(([key, value]) => (
    <StatusCard
      key={key}
      title={`${key.charAt(0).toUpperCase() + key.slice(1)} Requests`}
      value={value}
      iconClass={`ti ti-${key === 'approved' ? 'circle-check text-success' : key === 'pending' ? 'clock text-warning' : key === 'total' ? 'list-check text-primary' : 'circle-x text-danger'} fs-18`}
      bgClass={`bg-${key === 'approved' ? 'success' : key === 'pending' ? 'warning' : key === 'rejected' ? 'danger' : 'primary'}-transparent border border-${key}`}
    />
  ));


export  const getPendingCount = (data: any[], statusField: string) => {
  if (!Array.isArray(data)) return 0;
  return data.filter(item => item?.[statusField] === "Pending").length;
};

  
